"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { ignoreRefusal, requestJson } from "@/lib/clientRequest";
import type { SessionUser, SidebarMode } from "./types";

/** Who is signed in, the settings and developer links, and sign out. */
export function SidebarFooter({
  sessionInfo,
  mode,
  pathname,
  onCloseDrawer,
}: {
  sessionInfo: SessionUser | null;
  mode: SidebarMode;
  pathname: string;
  onCloseDrawer: () => void;
}) {
  const router = useRouter();
  return (
    <div className="border-t border-zinc-800 px-4 py-3">
      <div className="flex items-center gap-1.5">
        {sessionInfo && (
          <span
            title={`Signed in as ${sessionInfo.email}${sessionInfo.role === "admin" ? " (operator)" : ""}`}
            className="mr-auto max-w-32 truncate text-[11px] text-zinc-500"
          >
            {sessionInfo.name || sessionInfo.email}
            {sessionInfo.role === "admin" ? " ⚙" : ""}
          </span>
        )}
        <Link
          href="/settings"
          onClick={onCloseDrawer}
          title="Settings"
          className={`rounded-md px-2 py-1.5 text-[11px] transition hover:bg-zinc-800 hover:text-zinc-200 ${
            mode === "settings" ? "text-violet-300" : "text-zinc-500"
          }`}
        >
          Settings
        </Link>
        <Link
          href="/developer"
          onClick={onCloseDrawer}
          title="Developer tools"
          className={`rounded-md px-2 py-1.5 font-mono text-[11px] transition hover:bg-zinc-800 hover:text-zinc-200 ${
            pathname === "/developer" ? "text-violet-300" : "text-zinc-500"
          }`}
        >
          {"</>"}
        </Link>
        <button
          type="button"
          title="Sign out"
          onClick={async () => {
            onCloseDrawer();
            await requestJson("/api/auth/logout", { method: "POST" }).catch(ignoreRefusal);
            router.replace("/login");
            router.refresh();
          }}
          className="rounded-md px-2 py-1.5 text-[11px] text-zinc-500 transition hover:bg-zinc-800 hover:text-zinc-200"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
